import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
import { Calendar, User, Tag, FileText, Download, ArrowRight, Search, ExternalLink } from 'lucide-react';
export function MediaBlog() {
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const blogPosts = [{
    id: 1,
    title: 'New Study Reveals Link Between Gut Microbiome and Cognitive Function',
    excerpt: 'Our latest research uncovers significant correlations between specific gut bacteria populations and cognitive performance metrics in adults.',
    author: 'Azn Alahah',
    date: 'June 15, 2024',
    category: 'research',
    image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=80',
    featured: true,
    slug: 'gut-microbiome-cognition'
  }, {
    id: 2,
    title: 'CalMiR Announces Partnership with Global Health Initiative',
    excerpt: 'This collaboration will expand our Afya Program to bring microbiome health solutions to underserved communities in East Africa.',
    author: 'Michael Rodriguez',
    date: 'May 28, 2024',
    category: 'news',
    image: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=80',
    featured: true,
    slug: 'partnership-global-health'
  }, {
    id: 3,
    title: 'Understanding the Microbiota Reset Protocol: A Comprehensive Guide',
    excerpt: 'Learn about our evidence-based approach to restoring healthy gut microbiome balance after disruption from antibiotics or illness.',
    author: 'Dr. Aisha Johnson',
    date: 'April 12, 2024',
    category: 'education',
    image: 'https://images.unsplash.com/photo-1576086213369-97a306d36557?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=80',
    featured: false,
    slug: 'microbiota-reset-protocol'
  }, {
    id: 4,
    title: 'CalMiR Receives $5M Grant for Microbiome Research',
    excerpt: 'Funding will support innovative research on the gut-brain axis and development of new therapeutic interventions.',
    author: 'Communications Team',
    date: 'March 30, 2024',
    category: 'news',
    image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=80',
    featured: false,
    slug: 'grant-microbiome-research'
  }, {
    id: 5,
    title: 'The Role of Diet in Shaping Your Microbiome',
    excerpt: 'Our researchers explain how different dietary patterns influence microbial diversity and gut health.',
    author: 'Dr. David Kim',
    date: 'February 15, 2024',
    category: 'education',
    image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=80',
    featured: false,
    slug: 'diet-microbiome'
  }, {
    id: 6,
    title: 'Microbiome Testing: What You Need to Know',
    excerpt: 'A guide to understanding microbiome testing methods, their accuracy, and how to interpret results.',
    author: 'Azn Alahah',
    date: 'January 28, 2024',
    category: 'education',
    image: 'https://images.unsplash.com/photo-1579154341098-e4e158cc7f55?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=80',
    featured: false,
    slug: 'microbiome-testing'
  }];
  const pressReleases = [{
    id: 1,
    title: 'CalMiR Launches Ukweli Certified™ Program for Supplement Validation',
    date: 'May 5, 2024',
    excerpt: 'New certification program will provide independent verification of probiotic and microbiome supplement efficacy.'
  }, {
    id: 2,
    title: 'California Institute for Microbiome Research Expands Laboratory Facilities',
    date: 'April 20, 2024',
    excerpt: 'Expansion will double research capacity and create 30 new scientific positions.'
  }, {
    id: 3,
    title: 'CalMiR to Host International Microbiome Science Symposium',
    date: 'March 15, 2024',
    excerpt: 'Leading researchers from around the world will gather to share latest findings in microbiome science.'
  }];
  const mediaResources = [{
    id: 1,
    title: 'CalMiR Brand Assets',
    description: 'Logos, color guidelines, and approved imagery for media use.',
    link: '/media/brand-assets'
  }, {
    id: 2,
    title: 'Research Fact Sheets',
    description: 'Summaries of key research findings and methodologies.',
    link: '/media/fact-sheets'
  }, {
    id: 3,
    title: 'Executive Biographies',
    description: 'Professional backgrounds of CalMiR leadership team.',
    link: '/media/biographies'
  }, {
    id: 4,
    title: 'Media Contact Information',
    description: 'Contact details for press and media inquiries.',
    link: '/media/contacts'
  }];
  // Filter posts based on active tab and search query
  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory = activeTab === 'all' || post.category === activeTab;
    const matchesSearch = searchQuery === '' || post.title.toLowerCase().includes(searchQuery.toLowerCase()) || post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  // Get featured posts
  const featuredPosts = blogPosts.filter(post => post.featured);
  // Helper function to get the correct article URL
  const getArticleUrl = post => {
    return post.slug ? `/blog/${post.slug}` : `/blog/${post.id}`;
  };
  // Helper function to get the author URL
  const getAuthorUrl = authorName => {
    if (authorName === 'Azn Alahah') return '/authors/azn-alahah';
    // Add more authors as needed
    return '#';
  };
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1589" data-mp="36puv0wixme9h">
      <Header data-id="element-1590" data-mp="36sh1sty00pqn" />
      <main className="flex-grow" data-id="element-1591" data-mp="31r9sgqg7jihv">
        {/* Hero Section */}
        <section className="relative w-full bg-navy-50" data-id="element-1592" data-mp="31suo6je9d7hb">
          <div className="absolute inset-0 overflow-hidden" data-id="element-1593" data-mp="3frkmg2ctdd79">
            <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1512486130939-2c4f79935e4f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
            backgroundBlendMode: 'overlay'
          }} data-id="element-1594" data-mp="3foyg261nt3qm" />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-600/20 to-navy-600/20" data-id="element-1595" data-mp="12k34d9nycvjs" />
          </div>
          <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-1596" data-mp="ol3fc0wj2en3">
            <div className="max-w-3xl" data-id="element-1597" data-mp="tjn4ea6f46jo">
              <h1 className="text-3xl md:text-5xl font-bold text-navy-800 mb-4" data-id="element-1598" data-mp="tkprs84j7quu">
                Media & Blog
              </h1>
              <div className="w-20 h-1 bg-teal-600 mb-6" data-id="element-1599" data-mp="1ha0v9xd9nzco"></div>
              <p className="text-lg md:text-xl text-navy-700 mb-8" data-id="element-1600" data-mp="1m7aj58l0c2ye">
                Stay updated with the latest news, research findings, and
                educational content from the California Institute for Microbiome
                Research.
              </p>
            </div>
          </div>
        </section>

        {/* Featured Posts */}
        {featuredPosts.length > 0 && <section className="py-16 bg-white" data-id="element-1601" data-mp="24z3db6btbu7p">
            <div className="container mx-auto px-4" data-id="element-1602" data-mp="250wliq22qmht">
              <h2 className="text-2xl font-bold text-navy-800 mb-8" data-id="element-1603" data-mp="4wu0zc1enfll">
                Featured Articles
              </h2>
              <div className="grid md:grid-cols-2 gap-8" data-id="element-1604" data-mp="52cd71t7jy3">
                {featuredPosts.map(post => <div key={post.id} className="bg-navy-50 rounded-lg overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-1605" data-mp="3rcogt1wcrqg0">
                    <div className="h-48 overflow-hidden" data-id="element-1606" data-mp="nuwlbdj0cod2">
                      <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-1607" data-mp="ivtscrgay8lg" />
                    </div>
                    <div className="p-6" data-id="element-1608" data-mp="9xzu3ayz94vn">
                      <div className="flex items-center text-sm text-navy-500 mb-2" data-id="element-1609" data-mp="2zm0jy21pp785">
                        <span className="bg-teal-100 text-teal-800 px-2 py-1 rounded-full text-xs font-medium" data-id="element-1610" data-mp="2ulcuhkt4syg1">
                          {post.category.charAt(0).toUpperCase() + post.category.slice(1)}
                        </span>
                        <span className="mx-2" data-id="element-1611" data-mp="1f0kbou7l8faq">•</span>
                        <Calendar size={14} className="mr-1" data-id="element-1612" data-mp="1j3gxetsfcriw" />
                        <span data-id="element-1613" data-mp="1nv02io1e6jm8">{post.date}</span>
                      </div>
                      <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1614" data-mp="1nxcuzv4s0cdj">
                        {post.title}
                      </h3>
                      <p className="text-navy-600 mb-4" data-id="element-1615" data-mp="1xswlg20kmiuw">{post.excerpt}</p>
                      <div className="flex items-center justify-between" data-id="element-1616" data-mp="22sj0mgzym96c">
                        <div className="flex items-center text-sm text-navy-500" data-id="element-1617" data-mp="22taot6r894ml">
                          <User size={14} className="mr-1" data-id="element-1618" data-mp="26tkra9ft9cwp" />
                          <a href={getAuthorUrl(post.author)} className="hover:text-teal-600" data-id="element-1619" data-mp="8ezuwjvrzk9y">
                            {post.author}
                          </a>
                        </div>
                        <a href={getArticleUrl(post)} className="text-teal-600 hover:text-teal-700 font-medium flex items-center" data-id="element-1620" data-mp="1cg9650zsv99z">
                          Read more
                          <ArrowRight size={16} className="ml-1" data-id="element-1621" data-mp="1mf83hnf47iho" />
                        </a>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </section>}

        {/* Blog Posts */}
        <section className="py-16 bg-navy-50" data-id="element-1622" data-mp="205jx5qrclpax">
          <div className="container mx-auto px-4" data-id="element-1623" data-mp="206lhymy61q5u">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8" data-id="element-1624" data-mp="25569lxzcr1io">
              <h2 className="text-2xl font-bold text-navy-800 mb-4 md:mb-0" data-id="element-1625" data-mp="2a4snm9n08lsj">
                Latest Articles
              </h2>
              <div className="flex flex-col md:flex-row gap-4" data-id="element-1626" data-mp="2f3vrhqr90lyx">
                {/* Search Bar */}
                <div className="relative" data-id="element-1627" data-mp="3hbuo6rk4zqf">
                  <input type="text" placeholder="Search articles..." className="pl-10 pr-4 py-2 border border-navy-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent w-full" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1628" data-mp="3um1w3yvebrd1" />
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-navy-400" size={16} data-id="element-1629" data-mp="m830iycc6802" />
                </div>
                {/* Category Tabs */}
                <div className="flex space-x-2 overflow-x-auto pb-2 md:pb-0" data-id="element-1630" data-mp="7hvszdnva9e5">
                  {['all', 'research', 'news', 'education'].map(category => <button key={category} className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap ${activeTab === category ? 'bg-teal-600 text-white' : 'bg-navy-200 text-navy-700 hover:bg-navy-300'}`} onClick={() => setActiveTab(category)} data-id="element-1631" data-mp="14yt3so5tjwtg">
                      {category === 'all' ? 'All' : category.charAt(0).toUpperCase() + category.slice(1)}
                    </button>)}
                </div>
              </div>
            </div>
            {filteredPosts.length === 0 ? <div className="text-center py-12 bg-white rounded-lg" data-id="element-1632" data-mp="2fp7jsradf6k2">
                <p className="text-navy-600" data-id="element-1633" data-mp="21pg1iectn409">
                  No articles found matching your criteria.
                </p>
              </div> : <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1634" data-mp="26oj6jyssxa88">
                {filteredPosts.map(post => <div key={post.id} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-1635" data-mp="3w1e8e9nnrnsz">
                    <div className="h-48 overflow-hidden" data-id="element-1636" data-mp="1kfvokzojmy4u">
                      <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-1637" data-mp="1khf4gp6af763" />
                    </div>
                    <div className="p-6" data-id="element-1638" data-mp="284n8l3rzca6j">
                      <div className="flex items-center text-sm text-navy-500 mb-2" data-id="element-1639" data-mp="283loyawwefd7">
                        <span className="bg-teal-100 text-teal-800 px-2 py-1 rounded-full text-xs font-medium" data-id="element-1640" data-mp="235tsd3lb652o">
                          {post.category.charAt(0).toUpperCase() + post.category.slice(1)}
                        </span>
                        <span className="mx-2" data-id="element-1641" data-mp="np38i21m1632">•</span>
                        <Calendar size={14} className="mr-1" data-id="element-1642" data-mp="nrpdpv1139i4" />
                        <span data-id="element-1643" data-mp="irjpypxvq75b">{post.date}</span>
                      </div>
                      <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1644" data-mp="35zh8p1hsylud">
                        {post.title}
                      </h3>
                      <p className="text-navy-600 mb-4" data-id="element-1645" data-mp="3awhdza6tvkkf">{post.excerpt}</p>
                      <div className="flex items-center justify-between" data-id="element-1646" data-mp="3fy6qyvdm28b5">
                        <div className="flex items-center text-sm text-navy-500" data-id="element-1647" data-mp="3jygv02hueond">
                          <User size={14} className="mr-1" data-id="element-1648" data-mp="2n8gaifoiaubv" />
                          <a href={getAuthorUrl(post.author)} className="hover:text-teal-600" data-id="element-1649" data-mp="2na14o46wsb97">
                            {post.author}
                          </a>
                        </div>
                        <a href={getArticleUrl(post)} className="text-teal-600 hover:text-teal-700 font-medium flex items-center" data-id="element-1650" data-mp="310wgnpcpf8h0">
                          Read more
                          <ArrowRight size={16} className="ml-1" data-id="element-1651" data-mp="28hh7dk6fwxzo" />
                        </a>
                      </div>
                    </div>
                  </div>)}
              </div>}
            <div className="mt-12 text-center" data-id="element-1652" data-mp="1rzcredqz9n6s">
              <a href="/blog/archive" className="px-6 py-3 bg-navy-200 text-navy-700 rounded-md hover:bg-navy-300 transition-colors duration-200 inline-flex items-center" data-id="element-1653" data-mp="1ry1osh99qlh9">
                View All Articles
                <ArrowRight size={16} className="ml-2" data-id="element-1654" data-mp="1daq9c49yuhbv" />
              </a>
            </div>
          </div>
        </section>

        {/* Press Releases */}
        <section className="py-16 bg-white" data-id="element-1655" data-mp="18bn4ajtzkb3w">
          <div className="container mx-auto px-4" data-id="element-1656" data-mp="14a1whcwb6n0k">
            <div className="max-w-3xl mx-auto" data-id="element-1657" data-mp="14bmr12imi5yf">
              <h2 className="text-2xl font-bold text-navy-800 mb-8" data-id="element-1658" data-mp="zb8h1exgolxr">
                Press Releases
              </h2>
              <div className="space-y-6" data-id="element-1659" data-mp="ucnfnc6h3w7q">
                {pressReleases.map(release => <div key={release.id} className="border-b border-navy-200 pb-6 last:border-0" data-id="element-1660" data-mp="knqiyzeempkb">
                    <div className="flex items-center text-sm text-navy-500 mb-2" data-id="element-1661" data-mp="pkqgun13om0c">
                      <Calendar size={14} className="mr-1" data-id="element-1662" data-mp="arnazcwvfwpg" />
                      <span data-id="element-1663" data-mp="fpyhpervdr3g">{release.date}</span>
                    </div>
                    <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1664" data-mp="13erk9u2zyx71">
                      {release.title}
                    </h3>
                    <p className="text-navy-600 mb-4" data-id="element-1665" data-mp="18c9ioqje1u0s">{release.excerpt}</p>
                    <a href={`/press-releases/${release.id}`} className="text-teal-600 hover:text-teal-700 font-medium flex items-center" data-id="element-1666" data-mp="tpgby9nxpwk7">
                      Read full release
                      <ArrowRight size={16} className="ml-1" data-id="element-1667" data-mp="1mc13ba4eu8nr" />
                    </a>
                  </div>)}
              </div>
              <div className="mt-8" data-id="element-1668" data-mp="3btxwz4ecn0uk">
                <a href="/press-releases" className="text-teal-600 hover:text-teal-700 font-medium flex items-center justify-center" data-id="element-1669" data-mp="3bswliytf8ccb">
                  View all press releases
                  <ArrowRight size={16} className="ml-1" data-id="element-1670" data-mp="3lm3pqgcfdmat" />
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Media Resources */}
        <section className="py-16 bg-navy-50" data-id="element-1671" data-mp="2svvgjdzvac8d">
          <div className="container mx-auto px-4" data-id="element-1672" data-mp="2nx1zjbldg33g">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1673" data-mp="2nyd1r6z652sg">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-1674" data-mp="31xcr6gui9lpo">
                Media Resources
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-1675" data-mp="2xt52gjo1s5rg"></div>
              <p className="text-navy-600" data-id="element-1676" data-mp="h5ayo2v2ubpq">
                Access official resources for media professionals covering
                CalMiR and our research.
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-1677" data-mp="26nzg4lsdfxc9">
              {mediaResources.map(resource => <div key={resource.id} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-1678" data-mp="2bmsuegfhfsdh">
                  <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1679" data-mp="2ld5lkrhsyjsl">
                    {resource.title}
                  </h3>
                  <p className="text-navy-600 mb-4" data-id="element-1680" data-mp="2pfs94g7fxijz">{resource.description}</p>
                  <a href={resource.link} className="text-teal-600 hover:text-teal-700 font-medium flex items-center" data-id="element-1681" data-mp="2ub7k90e2d0cp">
                    Access resource
                    <Download size={16} className="ml-1" data-id="element-1682" data-mp="34a6tak2qqy08" />
                  </a>
                </div>)}
            </div>
            <div className="max-w-3xl mx-auto mt-12 text-center" data-id="element-1683" data-mp="19wnr2wxrmr8l">
              <div className="bg-teal-50 border border-teal-200 rounded-lg p-6" data-id="element-1684" data-mp="19x77283uv5jz">
                <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-1685" data-mp="3n8rwhmw5b8et">
                  Media Inquiries
                </h3>
                <p className="text-navy-600 mb-4" data-id="element-1686" data-mp="3iedz5exxar7i">
                  For interview requests, expert commentary, or other media
                  inquiries, please contact our media relations team.
                </p>
                <div className="flex flex-col md:flex-row items-center justify-center gap-4" data-id="element-1687" data-mp="a0oqtu8ix0wj">
                  <a href="mailto:media@calmir.org" className="flex items-center text-teal-600 hover:text-teal-700 font-medium" data-id="element-1688" data-mp="5z3k6qml1ius">
                    media@calmir.org
                    <ExternalLink size={16} className="ml-1" data-id="element-1689" data-mp="3s6thidd4thsx" />
                  </a>
                  <span className="hidden md:inline" data-id="element-1690" data-mp="2lpy79c7cc5r8">|</span>
                  <span className="text-navy-700" data-id="element-1691" data-mp="2lrj1f0pqtmok">(415) 555-0128</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Newsletter Signup */}
        <section className="py-16 bg-teal-600 text-white" data-id="element-1692" data-mp="2sfksrst8wvbk">
          <div className="container mx-auto px-4" data-id="element-1693" data-mp="2nn9supyi99j0">
            <div className="max-w-3xl mx-auto text-center" data-id="element-1694" data-mp="2nlgm7anw6pb0">
              <h2 className="text-3xl font-bold mb-4" data-id="element-1695" data-mp="2ipi05tq1djdr">Stay Updated</h2>
              <p className="text-teal-100 mb-8" data-id="element-1696" data-mp="2dpvq1t5i8j96">
                Subscribe to our newsletter to receive the latest news, research
                updates, and educational content from CalMiR.
              </p>
              <form className="max-w-md mx-auto" data-id="element-1697" data-mp="36drjmozs1v1q">
                <div className="flex flex-col md:flex-row gap-4" data-id="element-1698" data-mp="36byb145lt0r3">
                  <input type="email" placeholder="Your email address" className="px-4 py-3 rounded-md focus:ring-2 focus:ring-teal-300 focus:border-transparent flex-grow text-navy-800" required data-id="element-1699" data-mp="31dn1yvn4uu9x" />
                  <button type="submit" className="px-6 py-3 bg-white text-teal-600 rounded-md hover:bg-navy-50 transition-colors duration-200 font-medium" data-id="element-1700" data-mp="1kzn2fls796n7">
                    Subscribe
                  </button>
                </div>
                <div className="mt-4 text-sm text-teal-100" data-id="element-1701" data-mp="afsdi51135z8">
                  We respect your privacy. Unsubscribe at any time.
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-1702" data-mp="k6daxp4yu4gk" />
    </div>;
}